import React from "react";
import { useTranslation } from "react-i18next";

const FirstDeposit = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`promotions.firstDepositPromotion.content.${key}`);

  return (
    <div className="my-8">
      {/* <h1 className="text-3xl font-bold mb-6 text-red-600">
        {i18n("newMemberTopUp")}
      </h1> */}
      <h1 className="text-3xl font-bold mb-6 text-red-600">
        {i18n("newMemberTopUp2")}
      </h1>

      <h2 className="text-2xl font-bold mb-4">{i18n("eventDescription")}</h2>

      <div className="mb-4 ">
        <p className="text-red-500 mb-0">{i18n("note1.reminder")}</p>
        <span>{i18n("note1.serviceNote")}</span>
        <br />
        <span>{i18n("note1.serviceNote2")}</span>
      </div>

      <div className="mb-4">
        <p className="text-red-500 mb-0">{i18n("note2.reminder")}</p>
        {/* <span>{i18n("note2.example1")}</span>
        <br />
        <span>{i18n("note2.example2")}</span> */}
      </div>

      {/* <div className="mb-4">
        <p className="text-red-500 mb-0">{i18n("note3.reminder")}</p>
        <span>{i18n("note3.example")}</span>
      </div>

      <p className="text-red-600">{i18n("participationNote")}</p> */}

      <h1 className="text-2xl font-bold mb-6">{i18n("specialNotes")}</h1>
      <ul className="list-disc pl-5 mt-2">
        <li className="mb-4">{i18n("bulletPoints.point1")}</li>
        <li className="mb-4">{i18n("bulletPoints.point2")}</li>
        <li className="mb-4">{i18n("bulletPoints.point3")}</li>
        <li className="mb-4">{i18n("bulletPoints.point4")}</li>
        <li className="mb-4">{i18n("bulletPoints.point5")}</li>
        {/* <li className="mb-4">{i18n("bulletPoints.point6")}</li>
        <li className="mb-4">{i18n("bulletPoints.point7")}</li> */}
      </ul>
    </div>
  );
};

export default FirstDeposit;
